//create actions and export it
import { reactTableSlice } from "./react-table.reducer";

export const { addFilter } = reactTableSlice.actions;
export default reactTableSlice.actions;
